import axios from "axios";

export default {

	saveCourse(course){
		return axios.post("/v3/course", course);
	},

	getCourse(id) {
		return axios.get(`/v3/course/${id}`);
	},

	getCourses(ctx) {
		return axios.get("/v3/courses", {params: ctx});
	},

	assignAssessment(courseID, delivery) {
		return axios.post(`/v3/courses/assign/${courseID}`, delivery);
	},
	assignAssessmentToClasses(courseID, delivery) {
		return axios.post(`/v3/classes/${courseID}/delivery`, delivery);
	},




//================================ CLASS STUFF TO DELETE ==============================//
	listClasses(ctx, preload) {
		if (preload != undefined) {
			ctx.p = preload;
		}
		return axios.get("/v3/classes", { params: ctx });
	},

	listClassesWithStudents(ctx, districtID) {
		if (districtID != undefined) {
			ctx.district_id = districtID;
		}
		return axios.get("/v3/classes+students", { params: ctx });
	},

	getMyClasses(ctx, preload) {
		if (preload != undefined) {
			ctx.p = preload;
		}
		return axios.get("/v3/classes/mine", { params: ctx });
	},

	getTeacherClasses(teacherID) {
		return axios.get(`/v3/teacher/${teacherID}/classes`);
	},

	getClass(id, preload) {
		var ctx;
		if (preload != undefined) {
			ctx = { p: preload };
		}
		return axios.get(`/v3/class/${id}`, { params: ctx });
	},

	getClassAndAssessments(id) {
		return axios.get(`/v3/class+asmts/${id}`);
	},

	saveClass(classObj) {
		return axios.post("/v3/class", classObj);
	},

	removeClass(id) {
		return axios.delete(`/v3/class/${id}`);
	},

	saveDelivery(classID, delivery) {
		return axios.post(`/v3/class/${classID}/delivery`, delivery);
	},

	saveStudentsToClass(classID, students) {
		return axios.post(`/v3/class/${classID}/students`, students);
	},

	getStudentResults(classID, studentID) {
		return axios.get(`/v3/class/${classID}/student/${studentID}/results`);
	},

	deleteDeliveriesByAssessment(classID, assessmentID) {
		return axios.delete(`/v3/class/${classID}/deliveries/${assessmentID}`);
	},

	deleteDelivery(classID, deliveryID) {
		return axios.delete(`/v3/class/${classID}/delivery/${deliveryID}`);
	},

	saveSubmissionWindows(classID, windows) {
		return axios.post(`/v3/class/${classID}/times`, windows);
	},

	getClassesForSearchBox(searchString, filterDistrict) {
		return axios.get(`/v3/searchbox/classes/${searchString}/${filterDistrict}`);
	}
};



// WEBPACK FOOTER //
// ./src/services/CourseService.js